import { Col } from '@opendoor/atoms/box';
import { Collapsible } from '@opendoor/atoms/collapsible';
import { Grid } from '@opendoor/atoms/grid';
import { Link } from '@opendoor/atoms/link';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import { IconChevronDown } from '@tabler/icons-react';
import type { ActiveMarket } from 'components/marketplace/types';

interface PopularMarketsProps {
  /** Markets to link to; the section renders nothing when empty. */
  markets: ActiveMarket[] | undefined;
  /** Extra classes for the wrapping section. */
  className?: string;
}

export const PopularMarkets = ({ markets, className }: PopularMarketsProps) => {
  if (!markets?.length) {
    return null;
  }

  return (
    <Collapsible.Root className={cn('flex w-full flex-col', className)}>
      <Collapsible.Trigger className="group flex w-full items-center justify-between gap-4 py-2 text-left">
        <Text as="span" className="text-body-md font-medium">
          Popular Markets
        </Text>
        <IconChevronDown
          aria-hidden
          size={20}
          className="shrink-0 text-od-content-secondary transition-transform duration-200 group-data-[panel-open]:rotate-180"
        />
      </Collapsible.Trigger>
      {/* Keeps these internal links in the server-rendered payload; base-ui
          drops a closed panel entirely otherwise. */}
      <Collapsible.Panel hiddenUntilFound>
        <Col className="pt-4">
          <Grid className="grid-cols-[repeat(auto-fill,minmax(calc(var(--spacing)*62.5),1fr))] gap-4">
            <Link
              href="/homes-for-sale-near-me"
              analyticsName="market-link-near-me"
              className="block"
            >
              <Text as="p" className="text-body-md text-od-content-secondary">
                Homes for sale near me
              </Text>
            </Link>
            {markets.map((market) => (
              <Link
                key={market.identifier}
                href={`/homes/${market.identifier}`}
                analyticsName={`market-link-${market.identifier}`}
                className="block"
              >
                <Text as="p" className="text-body-md text-od-content-secondary">
                  Houses for sale in {market.displayName}
                </Text>
              </Link>
            ))}
          </Grid>
        </Col>
      </Collapsible.Panel>
    </Collapsible.Root>
  );
};
